module.exports = __webpack_public_path__ + "static/media/GH21.1b8f245c.png";